// Utility per condivisione PDF con allegati REALI

// Genera blob PDF da documento react-pdf
export async function generaBlobPDF(documento) {
  const { pdf } = await import('@react-pdf/renderer');
  const blob = await pdf(documento).toBlob();
  return blob;
}

// Download PDF
export function downloadPDF(blob, nomeFile) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeFile;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// METODO 1: Share API (mobile perfetto, desktop parziale)
export async function condividiConShareAPI(blob, nomeFile, testo) {
  if (!navigator.share) {
    return { success: false, error: 'Share API non supportata' };
  }

  try {
    const file = new File([blob], nomeFile, { type: 'application/pdf' });
    
    // Verifica supporto file
    if (navigator.canShare && !navigator.canShare({ files: [file] })) {
      return { success: false, error: 'Condivisione file non supportata' };
    }

    await navigator.share({
      files: [file],
      title: nomeFile,
      text: testo
    });

    return { success: true };
  } catch (error) {
    if (error.name === 'AbortError') {
      return { success: false, error: 'Annullato dall\'utente' };
    }
    return { success: false, error: error.message };
  }
}

// METODO 2: Download + Apertura WhatsApp (fallback desktop)
export async function condividiWhatsAppConPDF(blob, nomeFile, testo) {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  
  // Su mobile: prova Share API
  if (isMobile && navigator.share) {
    const result = await condividiConShareAPI(blob, nomeFile, testo);
    if (result.success) {
      return { success: true, method: 'mobile-share' };
    }
  }

  // Fallback: scarica + apri WhatsApp
  downloadPDF(blob, nomeFile);
  
  setTimeout(() => {
    const testoCompleto = `${testo}\n\n📎 Ho appena scaricato il file: ${nomeFile}\nLo allego manualmente al messaggio.`;
    const url = `https://wa.me/?text=${encodeURIComponent(testoCompleto)}`;
    window.open(url, '_blank');
  }, 500);

  return { 
    success: true, 
    method: 'download-then-whatsapp',
    message: 'PDF scaricato! Ora apriti WhatsApp e allega il file manualmente.' 
  };
}

// METODO 3: Download + Apertura Email (fallback desktop)
export async function condividiEmailConPDF(blob, nomeFile, destinatario, oggetto, corpo) {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  
  // Su mobile: prova Share API
  if (isMobile && navigator.share) {
    const result = await condividiConShareAPI(blob, nomeFile, corpo);
    if (result.success) {
      return { success: true, method: 'mobile-share' };
    }
  }

  // Fallback: scarica + apri mailto
  downloadPDF(blob, nomeFile);
  
  setTimeout(() => {
    const corpoCompleto = `${corpo}\n\n📎 Ho appena scaricato il file: ${nomeFile}\nLo allego manualmente all'email.`;
    const mailto = `mailto:${destinatario}?subject=${encodeURIComponent(oggetto)}&body=${encodeURIComponent(corpoCompleto)}`;
    window.location.href = mailto;
  }, 500);

  return { 
    success: true, 
    method: 'download-then-email',
    message: 'PDF scaricato! Ora apriti l\'email e allega il file manualmente.' 
  };
}
